import React, { useState, useEffect } from 'react';
import './kontakt.css';
import SecondaryButton from '../../components/secondaryButton';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../../firebase';

const Kontakt = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [kontaktData, setKontaktData] = useState({
    title: 'Kontakt os',
    textBefore: '',
    textAfter: '',
    mapEmbedUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2249.48542760096!2d12.5863163159285!3d55.680380980536!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4652533c5c803d23%3A0x4dd7edde69467b8!2sSankt%20Ann%C3%A6%20Pl.%2012%2C%201250%20K%C3%B8benhavn!5e0!3m2!1sda!2sdk!4v1645000000000!5m2!1sda!2sdk'
  });

  useEffect(() => {
    const fetchKontaktData = async () => {
      try {
        const kontaktDocRef = doc(db, 'content', 'kontakt');
        const kontaktDoc = await getDoc(kontaktDocRef);
        
        if (kontaktDoc.exists()) {
          const data = kontaktDoc.data();
          setKontaktData({
            title: data.title || 'Kontakt os',
            textBefore: data.textBefore || '',
            textAfter: data.textAfter || '',
            mapEmbedUrl: data.mapEmbedUrl || 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2249.48542760096!2d12.5863163159285!3d55.680380980536!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4652533c5c803d23%3A0x4dd7edde69467b8!2sSankt%20Ann%C3%A6%20Pl.%2012%2C%201250%20K%C3%B8benhavn!5e0!3m2!1sda!2sdk!4v1645000000000!5m2!1sda!2sdk'
          });
        }
      } catch (error) {
        console.error('Fejl ved hentning af kontakt data:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchKontaktData();
  }, []);

  if (isLoading) {
    return <div className="kontakt-loading">Indlæser...</div>;
  }

  return (
    <section className="kontakt">
      <section className="pp-om">
        <h2 className="pp-om__title">{kontaktData.title}</h2>
        
        {kontaktData.textBefore && (
          <div className="kontakt-tekstboks" dangerouslySetInnerHTML={{ __html: kontaktData.textBefore }} />
        )}
        
        <div className="pp-om__grid">
          <article className="pp-om__psykolog">
            <div className="pp-om__psykolog-billede">
              <img src="/media/om/maria.avif" alt="Maria Højer Nannestad" />
            </div>
            <div className="pp-om__psykolog-indhold">
              <div className="pp-om__psykolog-header">
                <h3 className="pp-om__psykolog-navn">Maria Højer Nannestad</h3>
              </div>
              <div className="pp-om__psykolog-tekst">
                <p>Autoriseret Psykolog, specialist i klinisk børne- og ungepsykologi samt psykoterapi med børn og med voksne. Specialistgodkendt supervisor.</p>
                <p><strong>Speciale i vold i nære relationer og tager udelukkende forløb med børn, unge og voksne, der har levet med vold i familien, fx i forbindelse med ophold på krisecenter.</strong></p>
              </div>
              <div className="pp-om__psykolog-kontakt">
                <p>Email: maria@psykologiskperspektiv.dk</p>
                <p>Tlf: 23 27 65 95</p>
              </div>
              <div className="pp-om__psykolog-button">
                <SecondaryButton href="/om/maria">Læs mere</SecondaryButton>
              </div>
            </div>
          </article>

          <article className="pp-om__psykolog">
            <div className="pp-om__psykolog-billede">
              <img src="/media/om/susanne.avif" alt="Susanne Wederkinck Nielsen" />
            </div>
            <div className="pp-om__psykolog-indhold">
              <div className="pp-om__psykolog-header">
                <h3 className="pp-om__psykolog-navn">Susanne Wederkinck Nielsen</h3>
              </div>
              <div className="pp-om__psykolog-tekst">
                <p>Autoriseret psykolog, specialist i klinisk børnepsykologi og psykoterapi med børn. Specialistgodkendt supervisor.</p>
                <p><strong>Speciale i Mentaliseringsbaseret terapi med børn, unge og familier samt supervision og undervisning i MBT.</strong></p>
              </div>
              <div className="pp-om__psykolog-kontakt">
                <p>Email: susanne@psykologiskperspektiv.dk</p>
                <p>Tlf: 61 12 66 85</p>
              </div>
              <div className="pp-om__psykolog-button">
                <SecondaryButton href="/om/susanne">Læs mere</SecondaryButton>
              </div>
            </div>
          </article>

          <article className="pp-om__psykolog">
            <div className="pp-om__psykolog-billede">
              <img src="/media/om/sidsel.avif" alt="Sidsel Linnet" />
            </div>
            <div className="pp-om__psykolog-indhold">
              <div className="pp-om__psykolog-header">
                <h3 className="pp-om__psykolog-navn">Sidsel Linnet</h3>
              </div>
              <div className="pp-om__psykolog-tekst">
                <p>Autoriseret Psykolog, Registered Clinical Psychologist. På vej til at blive specialist i Klinisk børne og Ungepsykologi.</p>
                <p><strong>Speciale i unge.</strong></p>
                <p><strong>Særlig erfaring og interesse i:</strong></p>
                <ul>
                  <li>engelsktalende klienter med expat-baggrund</li>
                  <li>vold i nære relationer</li>
                  <li>supervision og undervisning i MBT</li>
                </ul>
              </div>
              <div className="pp-om__psykolog-kontakt">
                <p>Email: sidsel@psykologiskperspektiv.dk</p>
                <p>Tlf: 53 85 11 75</p>
              </div>
              <div className="pp-om__psykolog-button">
                <SecondaryButton href="/om/sidsel">Læs mere</SecondaryButton>
              </div>
            </div>
          </article>
        </div>
        
        {kontaktData.textAfter && (
          <div className="kontakt-tekstboks" dangerouslySetInnerHTML={{ __html: kontaktData.textAfter }} />
        )}
      </section>
      
      <div className="kort-container">
        <iframe
          src={kontaktData.mapEmbedUrl}
          width="100%"
          height="450"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="Google Maps - Psykologisk Perspektiv"
        ></iframe>
      </div>
    </section>
  );
};

export default Kontakt;
